import { countryCodes } from '~~/i18n/enums/countryCodes';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

// Countries where category pages, /search and CMS listings use CT instead of Typesense.
export const USE_CT_AS_DATA_SOURCE_FOR_PLP_AND_SEARCH: Record<CountryCodeValue, boolean> = {
  [countryCodes.SK]: true,
  [countryCodes.IE]: true,
  [countryCodes.DE]: true,
  [countryCodes.PT]: true,
  [countryCodes.IT]: true,
  [countryCodes.FR]: true,
  [countryCodes.HU]: true,
  [countryCodes.CZ]: true,
  [countryCodes.AT]: true,
  [countryCodes.NO]: true,
  [countryCodes.NL]: true,
  [countryCodes.CH]: true,
  [countryCodes.BE]: true,
  [countryCodes.DK]: true,
  [countryCodes.SE]: true,
  [countryCodes.ES]: true,
  [countryCodes.GB]: true,
  [countryCodes.FI]: true,
  [countryCodes.PL]: true,
  [countryCodes.RO]: true,
  [countryCodes.LT]: true,
  [countryCodes.SI]: true,
  [countryCodes.BG]: true,
  [countryCodes.GR]: true,
  [countryCodes.HR]: true,
};
